import { apiClient } from './api';
import {
  PagedResponse,
  WhitelistEntry,
  AddWhitelistIpRequest,
  AddWhitelistPrefixRequest,
  UpdateWhitelistEntryRequest,
  WhitelistQueryRequest,
  WhitelistCheckResponse,
} from '../types/api';

export const whitelistService = {
  getAll: async (params: WhitelistQueryRequest): Promise<PagedResponse<WhitelistEntry>> => {
    const { data } = await apiClient.get('/whitelist', { params });
    return data;
  },

  getById: async (id: number): Promise<WhitelistEntry> => {
    const { data } = await apiClient.get(`/whitelist/${id}`);
    return data;
  },

  addIp: async (request: AddWhitelistIpRequest): Promise<WhitelistEntry> => {
    const { data } = await apiClient.post('/whitelist/ip', request);
    return data;
  },

  addPrefix: async (request: AddWhitelistPrefixRequest): Promise<WhitelistEntry> => {
    const { data } = await apiClient.post('/whitelist/prefix', request);
    return data;
  },

  update: async (id: number, request: UpdateWhitelistEntryRequest): Promise<WhitelistEntry> => {
    const { data } = await apiClient.put(`/whitelist/${id}`, request);
    return data;
  },

  remove: async (id: number): Promise<void> => {
    await apiClient.delete(`/whitelist/${id}`);
  },

  check: async (ipAddress: string): Promise<WhitelistCheckResponse> => {
    const { data } = await apiClient.get(`/whitelist/check/${ipAddress}`);
    return data;
  },
};
